import React, { useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Menu, Paper } from '@material-ui/core'
import { compose, withHandlers, withState } from 'recompose'

// Theme
import { bindActionCreators } from 'redux'

import { GraphHeading, StyledHeaderSpan, StyledMenuHeader, StyledMenuItem, StyledRightButton, TileStyle } from '../../theme/Global'
// Components
import Choropleth, {
  getStrokeByWage,
  getFillByWage,
  tooltipTextWage,
  getDomainBy,
  GEO_LIST
} from '../../common/components/drawMap'

import StateWageDetails from './stateWageDetails'
// Actions
import { modalClose, modalOpen } from '../../common/actions'
import { usStates } from '../../constants/localeNames'

const CurrentWageMapRenderer = ({ data, onMapClick, selectedCountry }) => {
  const [locationMenuAnchor, setLocationMenuAnchor] = useState(null)

  const mapData = () => data || [{}]

  const openLocationMenu = (e) => {
    setLocationMenuAnchor(e.currentTarget)
  }

  const closeLocationMenu = (e) => {
    setLocationMenuAnchor(null)
  }

  return (
    <React.Fragment>
      <Paper style={TileStyle}>
        <GraphHeading>
          <StyledHeaderSpan>Current Wage Information</StyledHeaderSpan>
          <StyledRightButton onClick={openLocationMenu}>Select Location</StyledRightButton>
          <Menu
            anchorEl={locationMenuAnchor}
            open={Boolean(locationMenuAnchor)}
            onClose={closeLocationMenu}
            PaperProps={{
              style: {
                maxHeight: 100 * 4.5,
                width: '20ch'
              }
            }}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left'
            }}
            getContentAnchorEl={null}
          >
            <StyledMenuHeader
              key="United States"
              country="US"
              disabled
            >
              US States
            </StyledMenuHeader>
            {usStates.map((location) => (
              <StyledMenuItem
                key={location.name}
                country={location.localeRegion}
                onClick={() => {
                  closeLocationMenu()
                  onMapClick({ properties: { iso_a2: location.localeRegion, postal: location.localeID, gn_name: location.name } })
                }}
              >
                {location.name}
              </StyledMenuItem>
            ))}
          </Menu>
        </GraphHeading>
        <Choropleth
          ledgendFormat="$.2f"
          getDomainSpan={getDomainBy(mapData(selectedCountry.code), 'wageAmount')}
          onMapClick={onMapClick}
          mapData={data}
          getStrokeForState={getStrokeByWage}
          getFillForState={getFillByWage}
          getTooltipHtml={tooltipTextWage}
        />
      </Paper>
    </React.Fragment>
  )
}

CurrentWageMapRenderer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  onMapClick: PropTypes.func.isRequired
}

CurrentWageMapRenderer.defaultProps = {}

const getWageDataForMap = (state) => {
  if (
    !state
    || !state.minWage
    || !state.minWage.wagesByJurisdiction
    || !state.minWage.wagesByJurisdiction.US
  ) {
    return []
  }

  const federalWage = {
    stateAbv: 'federal',
    wageAmount: state.minWage.wagesByJurisdiction.US.wages['wage rate'].wage,
    hasMultiple: false,
    hasLocation: false
  }

  const locationWageData = []

  Object.keys(state.minWage.wagesByJurisdiction.US.states).map((stateAbv) => {
    const stateData = state.minWage.wagesByJurisdiction.US.states[stateAbv]

    const converted = {
      stateAbv,
      wageAmount: null,
      hasMultiple: false,
      hasLocation: false
    }

    if (Object.keys(stateData.cities).length > 0 || Object.keys(stateData.counties).length > 0) {
      converted.hasMultiple = true
    }
    // map doesn't want to know about wage rates lower than federal
    if (stateData.wages['wage rate'] && stateData.wages['wage rate'].wage >= federalWage.wageAmount) {
      converted.wageAmount = stateData.wages['wage rate'].wage
    }
    locationWageData.push(converted)
  })

  locationWageData.push(federalWage)

  return locationWageData
}

const mapStateToProps = (state) => ({ data: getWageDataForMap(state) })

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    modalOpenDispatch: modalOpen,
    modalCloseDispatch: modalClose
  },
  dispatch
)

const CurrentWageMapComponent = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withState('selectedCountry', 'setSelectedCountry', GEO_LIST[0]),
  withHandlers({
    onMapClick: (props) => (event) => {
      const state = event.properties.postal

      props.modalOpenDispatch({
        title: `Minimum Wage Data for ${event.properties.gn_name}`,
        component: (
          <StateWageDetails country={event.properties.iso_a2} state={state} />
        )
      })
    }
  })
)(CurrentWageMapRenderer)

export default CurrentWageMapComponent
